__turbopack_context__.v({
  "bar": "_4xEC_G_bar",
  "buttonWrap": "_4xEC_G_buttonWrap",
  "chart": "_4xEC_G_chart",
  "chartsList": "_4xEC_G_chartsList",
  "container": "_4xEC_G_container",
  "fill": "_4xEC_G_fill",
  "label": "_4xEC_G_label",
  "level--high": "_4xEC_G_level--high",
  "level--low": "_4xEC_G_level--low",
  "level--middle": "_4xEC_G_level--middle",
  "percentage": "_4xEC_G_percentage",
});
